export const getHasJWT = (): boolean => !!sessionStorage.getItem("auth_token");
export const getJWT = (): string | null => sessionStorage.getItem("auth_token");
export const setJWT = (authToken: string): void =>
  sessionStorage.setItem("auth_token", authToken);

export const getHasRefreshToken = (): boolean =>
  !!sessionStorage.getItem("refresh_token");
export const getRefreshToken = (): string | null =>
  sessionStorage.getItem("refresh_token");
export const setRefreshToken = (refreshToken: string): void =>
  sessionStorage.setItem("refresh_token", refreshToken);

// Where to go after logging in: the ?next= page the user was signed out of,
// if it is a path on this site, otherwise the fallback. The browser's own URL
// parser decides, because it strips tabs/newlines and reads "\" as "/", so
// "/\t/evil.example" is really "//evil.example" - another site. Only the
// parsed path is returned, never the raw value.
export const getPostLoginPath = (search: string, fallback: string): string => {
  const next = new URLSearchParams(search).get("next");
  if (!next || !next.startsWith("/")) return fallback;
  try {
    const url = new URL(next, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
};
